"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  patchnotes: {
    id: "launcher.patchnotes.title",
    defaultMessage: "Patchnotes",
    description: ""
  },
  checkingForUpdates: {
    id: "launcher.patchnotes.checkingForUpdates",
    defaultMessage: "Checking for updates",
    description: ""
  },
  invalidUsernameOrPassword: {
    id: "launcher.patchnotes.invalidUsernameOrPassword",
    defaultMessage: "Invalid username or password.",
    description: ""
  },
  online: {
    id: "launcher.patchnotes.online",
    defaultMessage: "Online",
    description: ""
  },
  offline: {
    id: "launcher.patchnotes.offline",
    defaultMessage: "Offline",
    description: ""
  },
  noServerSelected: {
    id: "launcher.patchnotes.noServerSelected",
    defaultMessage: "No server selected",
    description: ""
  },
  thisServerIsOffline: {
    id: "launcher.patchnotes.thisServerIsOffline",
    defaultMessage: "This server is offline",
    description: ""
  },
  "serverPopulationGrade-FULL": {
    id: "launcher.populationGrade.full",
    defaultMessage: "FULL",
    description: ""
  },
  "serverPopulationGrade-HIGH": {
    id: "launcher.populationGrade.high",
    defaultMessage: "HIGH",
    description: ""
  },
  "serverPopulationGrade-MEDIUM": {
    id: "launcher.populationGrade.medium",
    defaultMessage: "MEDIUM",
    description: ""
  },
  "serverPopulationGrade-LOW": {
    id: "launcher.populationGrade.low",
    defaultMessage: "LOW",
    description: ""
  }
});

exports.default = _default;